import { Colors } from "veneer/Theme";

export type Color =
  | "blue"
  | "darkYellow"
  | "gray"
  | "green"
  | "magenta"
  | "purple"
  | "red"
  | "teal"
  | "yellow";

export const COLOR_OPTIONS = {
  blue: {
    backgroundColor: Colors.blue100,
    iconColor: Colors.blue700,
  },
  darkYellow: {
    backgroundColor: Colors.yellow300,
    iconColor: Colors.yellow700,
  },
  gray: {
    backgroundColor: Colors.gray100,
    iconColor: Colors.gray700,
  },
  green: {
    backgroundColor: Colors.green200,
    iconColor: Colors.green700,
  },
  magenta: {
    backgroundColor: Colors.magenta200,
    iconColor: Colors.magenta700,
  },
  purple: {
    backgroundColor: Colors.purple100,
    iconColor: Colors.purple700,
  },
  red: {
    backgroundColor: Colors.red200,
    iconColor: Colors.red700,
  },
  teal: {
    backgroundColor: Colors.teal100,
    iconColor: Colors.teal700,
  },
  yellow: {
    backgroundColor: Colors.yellow200,
    iconColor: Colors.yellow500,
  },
};
